import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as dashboardActions from '../../../pillar/dashboard/store/actions';
import * as ruleActions from '../actions';
import { ModuleConfiguration } from '../../business-rule.module.config';
import { ModuleListModel } from '../../models/ModuleListModel';
import { ModuleModel } from '../../models/ModuleModel';
import { ModuleState } from '../state/ModuleState';
import { RuleState } from '../state/RuleState';
import { RuleModel } from '../../models/RuleModel';
import { RuleListModel } from '../../models/RuleListModel';

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, RuleListModel, RuleModel, new TileState<RuleListModel, RuleModel>());

export function ruleReducer(state = new RuleState, action: dashboardActions.Actions<RuleModel>): RuleState {
  var selected = state.selected;
  var list = state.list;
  switch (action.type) {
    case ruleActions.ENABLE_RULE_SUCCESS:
      var enableAction = action as ruleActions.EnableRuleSuccessAction;
      if (state.selected && state.selected.ruleName === enableAction.payload.rule.ruleName) {
        selected = {
          ...state.selected,
          isEnabled: true
        }
      }
      var enableRuleList = state.list.find(r => r.ruleName === enableAction.payload.rule.ruleName);
      if (enableRuleList) {
        var newEnableRuleList = {
          ...enableRuleList,
          isEnabled: true,
        }
        list = list.filter(u => u !== enableRuleList).concat([newEnableRuleList]);
      }
      return {
        ...state,
        selected: selected,
        list: list
      }

    case ruleActions.DISABLE_RULE_SUCCESS:
      var disableAction = action as ruleActions.DisableRuleSuccessAction;
      if (state.selected && state.selected.ruleName === disableAction.payload.rule.ruleName) {
        selected = {
          ...state.selected,
          isEnabled: false
        }
      }
      var disableRuleList = state.list.find(r => r.ruleName === disableAction.payload.rule.ruleName);
      if (disableRuleList) {
        var newDisableRuleList = {
          ...disableRuleList,
          isEnabled: false
        }
        list = list.filter(u => u !== disableRuleList).concat([newDisableRuleList]);
      }
      return {
        ...state,
        selected: selected,
        list: list
      }

    case ruleActions.UPDATE_RULE_STATUS_SUCCESS:
      var updateAction = action as ruleActions.UpdateRuleStatusSuccessAction;
      if (state.selected && state.selected.ruleName === updateAction.payload.rule.ruleName) {
        selected = {
          ...state.selected,
          isEnabled: updateAction.payload.rule.isEnabled,
          disableReason: updateAction.payload.rule.disableReason
        }
      }
      var updateRuleList = state.list.find(r => r.ruleName === updateAction.payload.rule.ruleName);
      if (updateRuleList) {
        var newUpdateRuleList = {
          ...updateRuleList,
          isEnabled: updateAction.payload.rule.isEnabled,
          disableReason: updateAction.payload.rule.disableReason
        }
        list = list.filter(u => u !== updateRuleList).concat([newUpdateRuleList]);
      }
      return {
        ...state,
        selected: selected,
        list: list
      }

    default:
      return tileStateReducer(state, action) as RuleState;
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/reducers/rule.reducer.ts